import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(timezone);

const CustomDatePicker = ({ value, onChange, label }) => {
    const [selectedDate, setSelectedDate] = useState(dayjs(value));

    useEffect(() => {
        if (value) {
            setSelectedDate(dayjs(value));
        }
    }, [value]);

    const handleDateChange = (newValue) => {
        setSelectedDate(newValue);
        const formattedDate = newValue ? newValue.format('YYYY-MM-DDTHH:mm:ssZ') : '';
        onChange(formattedDate);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}  adapterLocale="ru">
            <DateTimePicker
                className='w-100'
                label={label}
                value={selectedDate}
                onChange={handleDateChange}
                sx={{
                    '& .MuiSvgIcon-root': {
                        color: '#fff',
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#CEFC4C',
                        },
                        '&:hover fieldset': {
                            borderColor: '#CEFC4C',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#CEFC4C',
                        },
                        '& input': {
                            color: '#fff',
                        },
                        '& textarea': {
                            color: '#fff',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#fff',
                        '&.Mui-focused': {
                            color: '#fff',
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;
